import { Component, OnInit } from '@angular/core';
import {PageService} from "../../service/page/page.service";
import {PageGuide} from "../../service/page/page";
import {ActivatedRoute, Router} from "@angular/router";
import {GtmService} from "../../service/gtm/gtm.service";

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
  providers: [PageService]
})
export class GuideComponent implements OnInit {
  location: string;
  search: string;

  guideList: PageGuide[];

  constructor(private pageService: PageService,
              private router: Router,
              private route: ActivatedRoute,
              private gtmService: GtmService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(
      params => {
        this.search = params['search'];
        if (!this.search) this.search = '';
        this.location = params['location'];
        if (!this.location) this.location = 'seongsu';

        this.pageService.getGuide(this.location).subscribe(
          guideList => {
            this.guideList = this.search ?
              guideList.filter(({title, content}) => title.concat(content).includes(this.search)) :
              guideList;
            // console.log(this.guideList)
          },
          error => this.guideList = [new PageGuide()]
        );

        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': '이용가이드',
          'breadcrumb': 'Home > Member > 이용가이드'
        });
      }
    )
  }
  reload() {
    let url = this.router.url.split('?')[0];
    this.router.navigateByUrl(`${url}?` + (this.location ? `&location=${this.location}` : '') + (this.search ? `&search=${this.search}` : ''));
  }

  onSearch(term: string) {
    this.search = term;
    this.reload();
  }

  onFilter(location) {
    this.location = location;
    this.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/member/guide/guide.component.ts